/* eslint-disable camelcase */
import React from "react"
import * as style from "../../templates/index.module.scss"
import SecondaryButton from "../SecondaryButton"

const ProductHighlightsBannerBelow = ({ blok }) => {
  const {
    background_img,
    background_img_mobile,
    tag,
    title,
    sub_title,
    cta_link,
  } = blok

  return (
    <div className={`${style.highlightBanner} flex-row-reverse`}>
      <img
        src={background_img_mobile}
        alt=""
        className="relative sm:block md:hidden w-screen mb-0"
      />
      <img
        src={background_img}
        alt=""
        className="relative hidden sm:hidden md:block w-screen mb-0"
      />
      <div className={`${style.data} absolute`}>
        <div className="tag bg-grey-dark text-white font-bold text-sm inline-block px-4 pb-[2px] pt-[7px] rounded-tl-lg rounded-br-lg">
          {tag}
        </div>
        <div className="title font-black text-white text-4xl md:text-4xl lg:text-5xl mt-4">
          {title}
        </div>
        <div className="sub-title font-expanded text-white text-sm lg:text-md">
          {sub_title}
        </div>
        <div className="mt-3">
          <SecondaryButton
            text="SHOP NOW"
            link={cta_link}
            buttonStyle="white"
          />
        </div>
      </div>
    </div>
  )
}

export default ProductHighlightsBannerBelow
